import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth } from '../context/AuthContext';

export default function Login() {
    const [address, setAddress] = useState("address");
    const navigate = useNavigate();
    const { setIsAuthenticated } = useAuth();
  const handleLogin = () => {
    sessionStorage.setItem('userData', JSON.stringify({ user: 'test' }));
    setIsAuthenticated(true);
    navigate("/home");
  };
  useEffect(() => {
    setIsAuthenticated(!!sessionStorage.getItem('userData'));
  });

  return (
    <div className="container-fluid">
      <div
        className="row h-100 align-items-center justify-content-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
          <div className="bg-secondary rounded p-4 p-sm-5 my-4 mx-3">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <a href="/" >
                <h3 className="text-primary">
                  <i className="fa fa-user-edit me-2" />
                  Quantium Chain
                </h3>
              </a>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-3">
              
                <h6 className="text-primary">
                  Welcome to Quantium Chain. Please click sign in to continue with CrypotWallet.
                </h6>
              
            </div>
            
            <button type="submit" onClick={handleLogin} className="btn btn-primary py-3 w-100 mb-4">
              Sign In With CrypotWallet
            </button>
            <p className="text-center mb-0 text-primary">
              Don't have an Account? <a href="/register">Sign Up</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
